<template>
    <div 
        v-tinymce="options"
        :key="renderKey"
        @mce-change="(stats) => offerSectionSet({salesStats: stats})"
        @mce-dirty="() => $emit('dirty')"
    >
        <div v-if="offerSections.salesStats" v-html="offerSections.salesStats"></div>
        <div v-else class="alert alert-gebucht mb-4">
            <h4 class="mb-0">{{ $t('salesStats.text', { count: formattedBookingCount, sales: $options.filters.currency(sales) }) }}</h4>
        </div>
    </div>
</template>

<script>

import placeholder from './placeholder';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { formatNumber } from '../../misc/LocaleFormat';

export default {
    name: 'SalesStats',
    props: { 
        options: Object
    },
    mixins: [placeholder],
    data() {
        return {
            renderKey: 0,
        }
    },
    mounted() {
        this.fetchSalesStatistic()
    },
    computed: {
        ...mapGetters(['offer', 'offerSections', 'inhouseSales', 'bookingCount', 'openSales']),
        sales: function () {
            return this.inhouseSales && this.openSales
                ? parseInt(this.inhouseSales) + parseInt(this.openSales)
                : this.placeholder;
        },
        formattedBookingCount: function () {
            return this.bookingCount
                ? formatNumber(parseInt(this.bookingCount), this.offer.language || 'de')
                : this.placeholder;
        },
        currentYear() {
            return this.inhouseSales && this.openSales
                ? parseInt(this.inhouseSales) + parseInt(this.openSales)
                : this.placeholder;
        }
    },
    methods: {
        ...mapActions([
            'fetchSalesStatistic',
        ]),
        ...mapMutations([
            'offerSectionSet',
        ])
    },
    watch: {
        inhouseSales: function () {
            this.renderKey++;
        },
        openSales: function () {
            this.renderKey++;
        },
        options: function () {
            this.renderKey++;
        }
    }
}
</script>
